import { api as defaultApi } from './api';
import { ApplicationState } from 'app/types-store';
import { ActionDispatching } from 'app/types-shared';
import * as navigate from 'app/area/shared/navigation';
import { CreateEditDraft } from 'app/area/case/edit/action-types';
import { ErrorNotification } from 'app/infrastructure/notifications/user-messages';
import { actionCreators as responseCachingActionCreators } from 'app/area/shared/response-caching/actions';
import { createDescriptionSelector } from 'app/infrastructure/translate';
import { HttpStatusCodes } from 'app/infrastructure/remote-data';
import { isCaseViewModalOpen } from 'app/components/helpers';
import { headerTranslation } from 'app/shell/constants';

export const actionCreators = (api: any = defaultApi) => ({

  editCase: (caseId: number, caseContextId: number = undefined, entityPath: string = undefined):
    ActionDispatching<any, ApplicationState> =>
    async (dispatch: any, getState: () => ApplicationState) => {

      const state = getState();
      const translate = createDescriptionSelector(state.app.texts);

      try {
        dispatch(new CreateEditDraft(caseId));

        const utcOffset = state.app.settings?.utcOffset;
        const { location: draftId, response } = await api.editCase(caseId, caseContextId, undefined, utcOffset);

        // Precache ui-definition
        if (response && response.data && response.data.caseContext && response.data.caseType) {
          const returnedCaseTypeId = response.data.caseType.v;
          const returnedCaseContextId = response.data.caseContext.v;
          dispatch(responseCachingActionCreators.getUiDefinition(returnedCaseTypeId, returnedCaseContextId));
        }

        isCaseViewModalOpen() ?
          navigate.toDraftCaseViewModal(draftId, undefined, entityPath) :
          navigate.toDraft(draftId, undefined, entityPath);
      } catch (err) {
        if (err.response?.status === HttpStatusCodes.TOO_MANY_REQUESTS) {
          const errorText = translate(headerTranslation.message_too_many_requests);
          dispatch(new ErrorNotification(errorText));
          isCaseViewModalOpen() ? navigate.toCaseViewModal(caseId) : navigate.toCaseView(caseId);
        } else {
          dispatch(new ErrorNotification(err.userMessages || err.message));
        }
        isCaseViewModalOpen() ? navigate.toCaseViewModal(caseId) : navigate.toCaseView(caseId);
      }
    }
});
